"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadInstantWinPrizes = loadInstantWinPrizes;
exports.loadInstantWinUserPrizes = loadInstantWinUserPrizes;
exports.loadInstantWinAllPrizes = loadInstantWinAllPrizes;
exports.watchLoadInstantWinPrizes = watchLoadInstantWinPrizes;
exports.watchLoadInstantWinUserPrizes = watchLoadInstantWinUserPrizes;
exports.watchLoadInstantWinAllPrizes = watchLoadInstantWinAllPrizes;
exports["default"] = exports.challengeSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _utils = require("../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _selectors = require("./selectors");

var _marked = _regenerator["default"].mark(loadInstantWinPrizes),
    _marked2 = _regenerator["default"].mark(loadInstantWinUserPrizes),
    _marked3 = _regenerator["default"].mark(loadInstantWinAllPrizes),
    _marked4 = _regenerator["default"].mark(watchLoadInstantWinPrizes),
    _marked5 = _regenerator["default"].mark(watchLoadInstantWinUserPrizes),
    _marked6 = _regenerator["default"].mark(watchLoadInstantWinAllPrizes);

function loadInstantWinPrizes(api, action) {
  var _action$payload, challengeId, clientId, res;

  return _regenerator["default"].wrap(function loadInstantWinPrizes$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, challengeId = _action$payload.challengeId, clientId = _action$payload.clientId;
          _context.prev = 1;
          _context.next = 4;
          return api.instantWinApi.getPrizesCount({
            challengeId: challengeId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          res = _context.sent;
          _context.next = 7;
          return (0, _effects.put)(_actions["default"].loadInstantWinPrizesSuccess({
            data: res.data
          }));

        case 7:
          _context.next = 13;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          _context.next = 13;
          return (0, _effects.put)(_actions["default"].loadInstantWinPrizesError(true));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 9]]);
}

function loadInstantWinUserPrizes(api, action) {
  var _action$payload2, challengeId, userId, res;

  return _regenerator["default"].wrap(function loadInstantWinUserPrizes$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload2 = action.payload, challengeId = _action$payload2.challengeId, userId = _action$payload2.userId;
          _context2.prev = 1;
          _context2.next = 4;
          return api.instantWinApi.getUserPrizes({
            challengeId: challengeId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          res = _context2.sent;
          _context2.next = 7;
          return (0, _effects.put)(_actions["default"].loadInstantWinUserPrizesSuccess({
            data: res.data[0].prizes
          }));

        case 7:
          _context2.next = 13;
          break;

        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 13;
          return (0, _effects.put)(_actions["default"].loadInstantWinUserPrizesError(true));

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 9]]);
}

function loadInstantWinAllPrizes(api, action) {
  var _action$payload3, challengeId, clientId, limit, skip, _yield$api$instantWin, meta, winnersDataApi, winnersDataSelector, winnersData;

  return _regenerator["default"].wrap(function loadInstantWinAllPrizes$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload3 = action.payload, challengeId = _action$payload3.challengeId, clientId = _action$payload3.clientId, limit = _action$payload3.limit, skip = _action$payload3.skip;
          _context3.prev = 1;
          _context3.next = 4;
          return api.instantWinApi.getAllPrizes({
            challengeId: challengeId,
            clientId: clientId,
            limit: limit,
            skip: skip
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$api$instantWin = _context3.sent;
          meta = _yield$api$instantWin.meta;
          winnersDataApi = _yield$api$instantWin.data;
          _context3.next = 9;
          return (0, _effects.select)(_selectors.getInstantWinWinnersDataSelector);

        case 9:
          winnersDataSelector = _context3.sent;
          winnersData = winnersDataSelector || [];
          winnersDataApi.forEach(function (item) {
            var hasDuplicateId = winnersDataSelector === null || winnersDataSelector === void 0 ? void 0 : winnersDataSelector.find(function (winner) {
              var _item$user;

              return (winner === null || winner === void 0 ? void 0 : winner._id) === ((_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user._id);
            });

            if (item.isWon && item.user && !hasDuplicateId) {
              winnersData.push(item.user);
            }
          });
          _context3.next = 14;
          return (0, _effects.put)(_actions["default"].loadInstantWinAllPrizesSuccess({
            meta: meta,
            data: winnersData
          }));

        case 14:
          _context3.next = 20;
          break;

        case 16:
          _context3.prev = 16;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 20;
          return (0, _effects.put)(_actions["default"].loadInstantWinAllPrizesError(true));

        case 20:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 16]]);
}

function watchLoadInstantWinPrizes(api) {
  return _regenerator["default"].wrap(function watchLoadInstantWinPrizes$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadInstantWinPrizes), loadInstantWinPrizes, api);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function watchLoadInstantWinUserPrizes(api) {
  return _regenerator["default"].wrap(function watchLoadInstantWinUserPrizes$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadInstantWinUserPrizes), loadInstantWinUserPrizes, api);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function watchLoadInstantWinAllPrizes(api) {
  return _regenerator["default"].wrap(function watchLoadInstantWinAllPrizes$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadInstantWinAllPrizes), loadInstantWinAllPrizes, api);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

var challengeSagas = function challengeSagas(api) {
  return [(0, _effects.fork)(watchLoadInstantWinPrizes, api), (0, _effects.fork)(watchLoadInstantWinUserPrizes, api), (0, _effects.fork)(watchLoadInstantWinAllPrizes, api)];
};

exports.challengeSagas = challengeSagas;
var _default = challengeSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map